import { createRouter, createWebHistory } from 'vue-router';
import { requireAuth, redirectIfAuthenticated } from '../utils/auth';
import HomePage from '../views/Home-page.vue';
import AboutPage from '../views/About-page.vue';
import ContactPage from '../views/Contact-page.vue';
import ServicesPage from '../views/Services-page.vue';
import PlansPage from '../views/Plans-page.vue';
import BlogsPage from '../views/Blogs-page.vue';
import PortfolioPage from '../views/Portfolio-page.vue';
import LoginPage from '../views/Login-page.vue';
import DashboardPage from '../views/Dashboard-page.vue';
import DashboardHomePage from '../views/DashboardHome-page.vue';
import PortfolioManagementPage from '../views/PortfolioManagement-page.vue';
import SettingsPage from '../views/Settings-page.vue';
import ContactManagementPage from '../views/ContactManagement-page.vue';
import PrivacyPolicyPage from '../views/Privacy-policy-page.vue';
import TermsOfServicePage from '../views/Terms-of-service-page.vue';
import FaqsPage from '../views/Faqs-page.vue';
import SitemapPage from '../views/Sitemap-page.vue';
import CaseDetailPage from '../views/CaseDetail-page.vue';

const routes = [
  {
    path: '/', name: 'Home', component: HomePage,
    meta: {
      title: 'LR Pro Marketing - Agencia de Marketing Digital en República Dominicana',
      description: 'Especialistas en marketing digital, SEO, redes sociales y estrategias de crecimiento para empresas. Servicios profesionales en República Dominicana.',
      keywords: 'marketing digital, SEO, redes sociales, publicidad digital, agencia marketing, República Dominicana',
      image: new URL('@/assets/utility/home-image.webp', import.meta.url).href,
      imageWidth: '1200',
      imageHeight: '630',
      canonical: 'https://lrmarketing.pro/',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/about', name: 'About', component: AboutPage,
    meta: {
      title: 'Sobre Nosotros - LR Pro Marketing',
      description: 'Conoce más sobre nuestro equipo, misión e historia.',
      image: new URL('@/assets/utility/about-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/about',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: {
      title: 'Contacto - LR Pro Marketing',
      description: 'Contáctanos para más información y síguenos en nuestras redes sociales como Facebook, Instagram, Youtube y TikTok.',
      image: new URL('@/assets/utility/contact-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/contact',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/services', name: 'Services', component: ServicesPage,
    meta: {
      title: 'Servicios de Marketing Digital - SEO, Redes Sociales, Publicidad | LR Pro Marketing',
      description: 'Ofrecemos servicios completos de marketing digital: SEO, gestión de redes sociales, publicidad digital, estrategias de crecimiento y más. Especialistas en República Dominicana.',
      keywords: 'servicios marketing digital, SEO, redes sociales, publicidad digital, estrategia digital, República Dominicana',
      image: new URL('@/assets/utility/services-image.webp', import.meta.url).href,
      imageWidth: '1200',
      imageHeight: '630',
      canonical: 'https://lrmarketing.pro/services',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/plans', name: 'Planes', component: PlansPage,
    meta: {
      title: 'Planes de Servicio - LR Pro Marketing',
      description: 'Explora nuestros planes diseñados para satisfacer tus necesidades de marketing digital.',
      image: new URL('@/assets/utility/plans-image.webp', import.meta.url).href,
      imageWidth: '1248px',
      imageHeight: '678px',
      canonical: 'https://lrmarketing.pro/plans',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/blogs', name: 'Blogs', component: BlogsPage,
    meta: {
      title: 'Blog - LR Pro Marketing',
      description: 'Lee nuestras últimas noticias y consejos.',
      image: new URL('@/assets/utility/blogs-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/blogs',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/portfolio', name: 'Portfolio', component: PortfolioPage,
    meta: {
      title: 'Portafolio de Proyectos - Casos de Éxito en Marketing Digital | LR Pro Marketing',
      description: 'Explora nuestro portafolio de proyectos exitosos en marketing digital. Casos de estudio, resultados obtenidos y estrategias implementadas para empresas en República Dominicana.',
      keywords: 'portafolio marketing digital, casos de éxito, proyectos SEO, redes sociales, República Dominicana',
      image: new URL('@/assets/utility/services-image.webp', import.meta.url).href,
      imageWidth: '1200',
      imageHeight: '630',
      canonical: 'https://lrmarketing.pro/portfolio',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/login', name: 'Login', component: LoginPage,
    beforeEnter: redirectIfAuthenticated,
    meta: {
      title: 'Login - LR Pro Marketing',
      description: 'Acceso al panel administrativo.',
      canonical: 'https://lrmarketing.pro/login',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/dashboard', name: 'Dashboard', component: DashboardPage,
    beforeEnter: requireAuth,
    meta: {
      title: 'Dashboard - LR Pro Marketing',
      description: 'Panel administrativo.',
      canonical: 'https://lrmarketing.pro/dashboard',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: DashboardHomePage
      },
      {
        path: '/dashboard/portfolio',
        name: 'PortfolioManagement',
        component: PortfolioManagementPage
      },
      {
        path: '/dashboard/settings',
        name: 'Settings',
        component: SettingsPage
      },
      {
        path: '/dashboard/contacts',
        name: 'ContactManagement',
        component: ContactManagementPage
      }
    ]
  },
  {
    path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicyPage,
    meta: {
      title: 'Política de Privacidad - LR Pro Marketing',
      description: 'Conoce cómo protegemos tu información.',
      image: new URL('@/assets/utility/privacy-policy-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/privacy-policy',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/terms-of-service', name: 'TermsOfService', component: TermsOfServicePage,
    meta: {
      title: 'Términos de Servicio - LR Pro Marketing',
      description: 'Consulta nuestros términos y condiciones.',
      image: new URL('@/assets/utility/terms-service-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/terms-of-service',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/faqs', name: 'Faqs', component: FaqsPage,
    meta: {
      title: 'Preguntas Frecuentes - LR Pro Marketing',
      description: 'Encuentra respuestas rápidas a las preguntas más comunes sobre nuestros servicios, planes y soporte.',
      image: new URL('@/assets/utility/faqs-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/faqs',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/sitemap', name: 'Sitemap', component: SitemapPage,
    meta: {
      title: 'Mapa del Sitio - LR Pro Marketing',
      description: 'Encuentra lo que buscas en nuestra página.',
      image: new URL('@/assets/utility/home-image.webp', import.meta.url).href,
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/sitemap',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
  {
    path: '/cases/:title', name: 'CaseDetail', component: CaseDetailPage,
    meta: {
      title: 'Detalle del Caso - LR Pro Marketing',
      description: 'Descubre detalles sobre este caso.',
      image: '/src/assets/utility/case-detail-image.webp',
      imageWidth: '',
      imageHeight: '',
      canonical: 'https://lrmarketing.pro/cases/',
      ogType: 'website',
      twitterCard: 'summary_large_image'
    }
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

function updateMeta(property, content, attr = 'name') {
  if (!content) return; // Evita valores vacíos o undefined

  let metaTag = document.querySelector(`meta[${attr}="${property}"]`);
  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute(attr, property);
    document.head.appendChild(metaTag);
  }
  metaTag.setAttribute('content', content);
}

router.afterEach((to) => {
  document.title = to.meta.title || 'LR Pro Marketing';

  const fullUrl = `https://lrmarketing.pro${to.path}`;
  const imageUrl = to.meta.image || 'https://lrmarketing.pro/lr.png';

  updateMeta('description', to.meta.description);
  updateMeta('og:title', to.meta.title, 'property');
  updateMeta('og:description', to.meta.description, 'property');
  updateMeta('og:image', imageUrl, 'property');
  updateMeta('og:image:width', to.meta.imageWidth || '1200', 'property');
  updateMeta('og:image:height', to.meta.imageHeight || '630', 'property');
  updateMeta('og:url', fullUrl, 'property');
  updateMeta('og:type', to.meta.ogType || 'website', 'property');
  updateMeta('twitter:card', to.meta.twitterCard || 'summary_large_image');
  updateMeta('twitter:title', to.meta.title);
  updateMeta('twitter:description', to.meta.description);
  updateMeta('twitter:image', imageUrl);

  let linkCanonical = document.querySelector('link[rel="canonical"]');
  if (!to.meta.canonical) {
    if (linkCanonical) linkCanonical.remove();
  } else {
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', to.meta.canonical);
  }
});


export default router;
